module.exports = __webpack_public_path__ + "img/adult-megagrip-primal-flint.d73c2227.jpg";